import { getPageSetFromPath } from "@pageDefinitions/pageSets";
import { findEntryPointLocation } from "src/pageDefinitions/actions/survey/util";
import getStore from "src/utils/redux/store";
import { gotoPage } from "./pageSet";
import { getHistory } from "../components/PageSetRouter";
import {
  MED_SKU,
  MED_FLOW,
  getEligibleMedProducts,
  getBMI,
} from "@utils/medEligibility";
import { trackEvent } from "src/utils/api/tracker";
import { isFreemiumHealthRoute } from "src/utils/userSegment";
import { isHRTPatchEnabled } from "@utils/userSegment/features";
import goto from ".";

export const medSkuEntryPoints = {
  [MED_SKU.HRT_CREAM]: "hrtCreamPlan",
  [MED_SKU.HRT_PATCH]: "hrtPatchPlan",
};

export default {
  async navigateToHrtPlanRevealPage() {
    const store = getStore();
    const history = getHistory();
    const pageSet = await getPageSetFromPath(
      window.location.pathname,
      getStore().getState()
    );

    const { flow, recommendedMedTier } = store.getState().recommendationContext;
    const patchDisabled =
      recommendedMedTier === MED_SKU.HRT_PATCH && !isHRTPatchEnabled();
    // If patch is disabled and the server recommended it, fall back to cream
    // since it's the only remaining HRT option.
    const entryPoint = patchDisabled
      ? medSkuEntryPoints[MED_SKU.HRT_CREAM]
      : medSkuEntryPoints[recommendedMedTier];

    if (flow === MED_FLOW.CLINICAL && !entryPoint) {
      // Temporary adding logic with event to measure how many users are experiencing
      // the Med loop due to the old stored data https://noomhq.atlassian.net/browse/MGEXP-2227
      // For FreemiumHealthRoute, these questions are skipped in the survey flow
      const isFreemiumHealth = isFreemiumHealthRoute();

      const eligibleProducts = getEligibleMedProducts(
        {
          checkBMI: true,
          checkHealthRisks: false,
          checkState: false,
          checkFlow: true,
          requirePreviousMedicationsAnswer: !isFreemiumHealth,
          requireHighestBMIAnswer: !isFreemiumHealth,
          disabledNamedChecks: [
            "isQualifiedForPD",
            "isNotEligibleForCompoundedSemaglutide",
          ],
        },
        MED_FLOW.CLINICAL
      );

      if (eligibleProducts.length === 0) {
        trackEvent("BmiReasonPlanRevealNavigationFailed", {
          bmi: getBMI(),
        });
      }

      return goto.bail(
        "mainSurvey",
        [],
        "No entry point found for med tier payment results"
      );
    }

    const entryPointLocation = findEntryPointLocation(pageSet, entryPoint);
    return gotoPage(pageSet, { store, history }, false, entryPointLocation);
  },
};
